<template>
    <div class="vc-editable-input">
        <div class="vc-number" @mouseenter="showHandler" @mouseleave="hideHandler" v-show="inputHovered" v-if="numType">
            <div class="vc-number-handler vc-number-handler-up" :class="{ 'vc-number-handler-disabled': isMax }" @click="numUp">
                <svg class="handler-icon up-icon" :class="{ 'vc-number-handler-hover': !isMax }" viewBox="0 0 40 20">
                    <path d="M10 15 l10 -10 l10 10" fill="transparent" stroke-width="3" stroke="inherit" />
                </svg>
            </div>
            <div class="vc-number-handler vc-number-handler-down" :class="{ 'vc-number-handler-disabled': isMin }" @click="numDown">
                <svg class="handler-icon down-icon" :class="{ 'vc-number-handler-hover': !isMin }" viewBox="0 0 40 20">
                    <path d="M10 5 l10 10 l10 -10" fill="transparent" stroke-width="3" stroke="inherit" />
                </svg>
            </div>
        </div>
        <input
            maxlength="7"
            :aria-labelledby="labelId"
            class="vc-input__input"
            v-model="val"
            @keydown="handleKeyDown"
            @input="update"
            @mouseenter="showHandler"
            @mouseleave="hideHandler"
            ref="input"
        />
        <span :for="label" class="vc-input__label" :id="labelId">{{ labelSpanText }}</span>
        <span class="vc-input__desc">{{ desc }}</span>
    </div>
</template>

<script>
    export default {
        name: "editableInput",
        data: function () {
            return {
                inputHovered: false,
            };
        },
        props: {
            label: String,
            labelText: String,
            desc: String,
            value: Number | String,
            max: Number,
            min: {
                type: Number,
                default: 0,
            },
            arrowOffset: {
                type: Number,
                default: 1,
            },
        },
        computed: {
            val: {
                get() {
                    return this.value;
                },
                set(v) {
                    // TODO: min
                    if (this.numType && isNaN(v)) {
                        this.$refs.input.value = this.value;
                    }
                    if (this.numType && +v < this.min) {
                        this.$refs.input.value = this.min;
                    } else if (!(this.max === undefined) && +v > this.max) {
                        this.$refs.input.value = this.max;
                    } else {
                        return v;
                    }
                },
            },
            numType() {
                return this.label !== "#";
            },
            isMax() {
                return this.value == this.max;
            },
            isMin() {
                return this.value == this.min;
            },
            labelId() {
                return `input__label__${this.label}__${Math.random().toString().slice(2, 5)}`;
            },
            labelSpanText() {
                return this.labelText || this.label;
            },
        },
        methods: {
            showHandler() {
                this.inputHovered = true;
            },
            hideHandler() {
                this.inputHovered = false;
            },
            update(e) {
                this.handleChange(e.target.value);
            },
            numUp() {
                if (this.isMax) return;
                let val = this.val;
                let number = Number(val);
                let amount = this.arrowOffset || 1;
                val = number + amount;
                this.handleChange(val);
            },
            numDown() {
                if (this.isMin) return;
                let val = this.val;
                let number = Number(val);
                let amount = this.arrowOffset || 1;
                val = number - amount;
                this.handleChange(val);
            },
            handleChange(newVal) {
                let data = {};
                data[this.label] = this.numType ? newVal : newVal.slice(1);
                if (data.hex === undefined && data["#"] === undefined) {
                    this.$emit("change", data);
                } else if (newVal.length > 6) {
                    this.$emit("change", data);
                }
            },
            // **** unused
            // handleBlur (e) {
            //   console.log(e)
            // },
            handleKeyDown(e) {
                let val = this.val;

                let number = Number(val);

                if (number) {
                    let amount = this.arrowOffset || 1;

                    // Up
                    if (e.keyCode === 38) {
                        val = number + amount;
                        this.handleChange(val);
                        e.preventDefault();
                    }

                    // Down
                    if (e.keyCode === 40) {
                        val = number - amount;
                        this.handleChange(val);
                        e.preventDefault();
                    }
                }
            },
            // **** unused
            // handleDrag (e) {
            //   console.log(e)
            // },
            // handleMouseDown (e) {
            //   console.log(e)
            // }
        },
    };
</script>

<style lang="less">
    html.dark .vc-input__input {
        background-color: transparent;
    }
    .vc-number {
        position: absolute;
        top: 1px;
        right: 0;
        width: 18px;
        height: 23px;
        user-select: none;
    }
    .vc-number-handler {
        height: 50%;
        width: 100%;
        cursor: pointer;
        user-select: none;
        position: relative;
        border-left: 1px solid var(--border-color-vc-number-handler);
        cursor: pointer;
    }
    .handler-icon {
        height: 8px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        stroke: #999;
    }
    .vc-number-handler-hover:hover {
        stroke: var(--themeColor) !important;
    }
    .vc-number-handler-disabled {
        cursor: not-allowed !important;
    }

    .vc-number-handler-down {
        border-top: 1px solid var(--border-color-vc-number-handler);
        top: -1px;
    }

    .vc-editable-input {
        margin-bottom: 4px;
        position: relative;
    }
    .vc-input__input {
        text-indent: 6px;
        border-radius: 2px;
        user-select: none;
        margin-left: 16px;
        width: 54px;
        height: 24px;
        border: 1px solid var(--border-color-vc-input);
        // box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;
        margin-bottom: 5px;
        font-size: 13px;
        padding: 0;
        outline: none;
    }
    .vc-input__label {
        text-transform: capitalize;
        left: 0;
        top: 0;
        text-transform: uppercase;
        font-size: 13px;
        height: 18px;
        width: 34px;
        line-height: 22px;
        position: absolute;
    }
    .vc-input__desc {
        position: absolute;
        right: -3px;
        top: 3px;
        width: 0;
    }
</style>
